<script setup lang="ts">
import type { Ui } from './generated/fw'

const {
  uiBlockSize,
  uiInlineSize,
  grow
} = defineProps<{
  uiBlockSize?: Ui['uiBlockSize']
  uiInlineSize?: Ui['uiInlineSize']
  grow?: boolean | ''
}>()
</script>

<template>
  <span
    :class="$style.gap"
    :style="{
      flexGrow: grow === true || grow === '' || !uiBlockSize && !uiInlineSize ? 1 : 0
    }"
    :ui-block-size
    :ui-inline-size
  />
</template>

<style module>
.gap {
  margin-block: calc(0px - var(--block-gap, 0px) / 2);
  margin-inline: calc(0px - var(--inline-gap, 0px) / 2);
}
</style>
